module.exports = __webpack_public_path__ + "static/media/cc5.d01279d0.jpg";